import TextInputScanner from './TextInputScanner';

export default TextInputScanner;
